import React from "react";

import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";

const Manufacturing = () => {

    const { brandData, } = useTraceabilityData()
    const brandName = brandData?.logo?.brandName;
    const productName = brandData?.logo?.productName;

    return (


        <div className="">

            <div className="wrapper2">
                <h2 className="heading2">State-of-the-Art<br /> Manufacturing
                </h2>
            </div>

            <section className="py-0">
                <div className="container py-0">
                    {/* more blogs */}
                    <div className="row g-3">
                        <div className="col-lg-4 col-12">
                                <div className="product-item col">
                                    <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                        <img src="img/04.png" alt="" className="card-img-top" />
                                        <div className="position-absolute text-overlay text-white p-3">
                                            <h1 className="fw-bold opacity-50" style={{ fontSize: "4rem" }}>04</h1>
                                        </div>
                                    </div>
                                </div>
                            

                            <p className="card-text text-muted py-3 px-2">
                                Our manufacturing process transforms raw milk into premium {productName} using
                                advanced technology. Every step is closely monitored to meet the highest quality
                                standards, while our energy-efficient practices ensure sustainability by reducing
                                waste and maximizing resources. At {brandName}, we are proud to deliver products
                                that stand for quality and care.
                            </p>
                            <div className="underline2"></div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="bg-light">
                <div className="container p-3">
                    <h6 className="card-title fw-bold my-2">Manufacturing Insights</h6>

                    <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">

                        <Link to="/technology-at-work">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/m5-min.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3">
                                        <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                                            <br />Technology At Work
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/stringent-quality-testing">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/m2-min.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3">
                                        <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                                            <br />Stringent Quality Testing
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/certified-for-excellence">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/m3-min.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3">
                                        <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                                            <br />Certified for Excellence
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/smart-manufacturing">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/m4-min.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3"
                                        style={{ top: "30%" }}>
                                        <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                                            <br /><br />Smart Manufacturing
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                    </div>
                </div>
            </div>
            <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
                <Link
                    to="/cloud-connectivity-quality"
                    className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                >
                    Previous
                </Link>
                <Link
                    to="/technology-at-work"
                    className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                >
                    Next
                </Link>

            </div>
            {/* <Index/> */}
        </div>


    );
};

export default Manufacturing;
